import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import { useJobStatus } from '../contexts/JobStatusContext.jsx';
import { LucideRocket } from "lucide-react";
import { LucideFilePlus } from "lucide-react";

function ImportConfirmation({ onRestart, jobInfo }) {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const { openDrawer } = useJobStatus();

  useEffect(() => {
    function handleResize() {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Confetti
        width={dimensions.width}
        height={dimensions.height}
        recycle={false}
        numberOfPieces={500}
      />
      <div className="relative text-center p-8">
        <h2 className="text-2xl font-bold mb-4 dark:text-white">Traitement lancé 🎉</h2>
        <p className="mb-6 dark:text-gray-300">
          Votre traitement est en cours de préparation. Vous pouvez suivre son avancement dans le panneau des jobs.
        </p>



        <div className="flex flex-row gap-10 max-w-lg mx-auto">
          <button
            onClick={onRestart}
            className="px-6 py-3 bg-blue-600 dark:bg-blue-500 text-white rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors duration-200 w-full flex items-center justify-center gap-2"
          >
            <LucideFilePlus className="w-5 h-5" aria-hidden="true" />
            Traiter un autre fichier
          </button>
          <button
            onClick={openDrawer}
            className="px-6 py-3 bg-green-600 dark:bg-green-500 text-white rounded-lg hover:bg-green-700 dark:hover:bg-green-600 transition-colors duration-200 w-full flex items-center justify-center gap-2"
          >
            <LucideRocket className="w-5 h-5" aria-hidden="true" />
            Suivi des jobs
          </button>
        </div>
      </div>
    </>
  );
}

export default ImportConfirmation;
